import(/* webpackMode: "eager" */ "/app/features/DrawingOnlineControl/ui/HowStart/HowStart.tsx");
;
import(/* webpackMode: "eager" */ "/app/features/DrawingOnlineControl/ui/Tools/Tools.tsx");
;
import(/* webpackMode: "eager" */ "/app/features/DrawingOnlineControl/ui/WhyThat/WhyThat.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatabaseIcon"] */ "/app/shared/constants/icon.tsx");
;
import(/* webpackMode: "eager" */ "/app/widgets/Contact/Contact.tsx");
;
import(/* webpackMode: "eager" */ "/app/widgets/ProductHeader/ProductHeader.tsx");
